export const TOKEN = '@@session/TOKEN'
